import instanceAxios from './axiosConfig';
import { URL} from '../utility/util';

const userDetails = (initialContactId) => {
    let req = URL.PARAMS.USER_DETAILS;
    req.data.InitialContactId = initialContactId;

     return new Promise((resolve, reject)=>{
        instanceAxios.post('/mso-chat', req)
        .then((response)=>{
            if(response.data.status === 200) {
                resolve(response.data.data);
            } else {
                reject(response.data)
            }
        })
        .catch((error)=>{
            reject(error);
        })
     });
}

export { userDetails };